import { z } from 'zod';
import { BuyerResearchStageWithNonActive } from './BuyerResearchStage';
import { TopLevelRegion } from './TopLevelRegion';
export var SegmentState;
(function (SegmentState) {
    SegmentState["UPLOADED_TO_BEESWAX"] = "uploaded_to_beeswax";
    SegmentState["UPLOADED_TO_S3"] = "uploaded_to_s3";
    SegmentState["PROCESSING"] = "processing";
    SegmentState["ERROR"] = "error";
    SegmentState["PROCESSED"] = "processed";
    SegmentState["WAITING_FOR_PROCESSING"] = "waiting_for_processing";
    SegmentState["STATE_UNSPECIFIED"] = "unspecified";
})(SegmentState || (SegmentState = {}));
export var SegmentType;
(function (SegmentType) {
    SegmentType["SEGMENT_TYPE_UNSPECIFIED"] = "segment_type_unspecified";
    SegmentType["IP"] = "ip";
    SegmentType["USER_ID"] = "user_id";
    SegmentType["MAID"] = "maid";
})(SegmentType || (SegmentType = {}));
export var BeeswaxSegmentType;
(function (BeeswaxSegmentType) {
    BeeswaxSegmentType["IP"] = "IP_ADDRESS";
    BeeswaxSegmentType["MAID"] = "OTHER_MOBILE_ID";
    BeeswaxSegmentType["USER_ID"] = "BEESWAX";
})(BeeswaxSegmentType || (BeeswaxSegmentType = {}));
export var IsLiverampDerivedIdl;
(function (IsLiverampDerivedIdl) {
    IsLiverampDerivedIdl["YES"] = "Yes";
    IsLiverampDerivedIdl["NO"] = "No";
})(IsLiverampDerivedIdl || (IsLiverampDerivedIdl = {}));
export var LeadsStrategy = {
    accountsWithLeads: 'Accounts With Leads',
    accountsWithoutLeads: 'Accounts Without Leads',
};
export var LeadsStrategyValue;
(function (LeadsStrategyValue) {
    LeadsStrategyValue["accountsWithLeads"] = "accountsWithLeads";
    LeadsStrategyValue["accountsWithoutLeads"] = "accountsWithoutLeads";
})(LeadsStrategyValue || (LeadsStrategyValue = {}));
export var FiltersRelationship;
(function (FiltersRelationship) {
    FiltersRelationship["and"] = "and";
    FiltersRelationship["or"] = "or";
})(FiltersRelationship || (FiltersRelationship = {}));
export var createAutomatedProgrammaticSegmentSchema = z.object({
    tag: z.string().min(3),
    campaignId: z.number(),
    region: z.nativeEnum(TopLevelRegion),
    hasIspData: z.boolean().default(false),
    segmentType: z.nativeEnum(SegmentType),
    buyerResearchStages: z
        .nativeEnum(BuyerResearchStageWithNonActive, {
        errorMap: function () { return ({ message: 'Please select BRS stage' }); },
    })
        .array(),
    leadsStrategy: z.nativeEnum(LeadsStrategyValue).optional(),
    excludedAccounts: z.array(z.string()).optional(),
    filtersRelationship: z.nativeEnum(FiltersRelationship).optional(),
    targetPersonas: z.array(z.object({
        id: z.number(),
        name: z.string(),
    })),
});
export var leadsStrategyOptions = Object.entries(LeadsStrategy).map(function (_a) {
    var key = _a[0], label = _a[1];
    return ({
        value: key,
        label: label,
    });
});
export var filtersRelationshipOptions = Object.entries(FiltersRelationship).map(function (_a) {
    var key = _a[0], label = _a[1];
    return ({
        value: key,
        label: label.toLocaleUpperCase(),
    });
});
export var DSPProvider;
(function (DSPProvider) {
    DSPProvider["beeswax"] = "beeswax";
    DSPProvider["xandr"] = "xandr";
    DSPProvider["tradedesk"] = "tradedesk";
    DSPProvider["innovid"] = "innovid";
})(DSPProvider || (DSPProvider = {}));
export var dspProviderOptions = Object.entries(DSPProvider).map(function (_a) {
    var key = _a[0], label = _a[1];
    return ({
        value: key,
        label: label[0].toUpperCase() + label.slice(1),
    });
});
export var ForecastState;
(function (ForecastState) {
    ForecastState["SCHEDULED"] = "scheduled";
    ForecastState["PROCESSING"] = "processing";
    ForecastState["ERROR"] = "error";
    ForecastState["PROCESSED"] = "processed";
})(ForecastState || (ForecastState = {}));
//# sourceMappingURL=ProgrammaticDomains.js.map